module.exports = __webpack_public_path__ + "img/has-buy@3x.ff7d2cc7.png";